const baseUrl = 'https://sistemavdv.com/sisv/externo/consultas';

ko.bindingHandlers.distancia = {
    update: function(element, valueAccessor, allBindingsAccessor) {
        var value = ko.utils.unwrapObservable(valueAccessor());
        var measure = " metros"

        if(value > 1000){
            value = value / 1000;
            measure = " Km"
        }
            
        var precision = ko.utils.unwrapObservable(allBindingsAccessor().precision) || ko.bindingHandlers.distancia.defaultPrecision;
        var formattedValue = value.toFixed(precision);

           
        ko.bindingHandlers.text.update(element, function() { return formattedValue + measure; });
    },
    defaultPrecision: 1  
};

const ViewBag = function () {
    var data = {
        listaEstados: [],
        UrlAgendarCita: 'https://verdeverdad.com/pages/agenda-tu-cita',
        geoSettings: {
            enableHighAccuracy: true,
            maximumAge        : 30000,
            timeout           : 20000
        },
    };

    return data;
}();

var appVM = function () {

    var vm = {
        filtroEstadoId: ko.observable(0),
        filtroCiudadId: ko.observable(0),

        positionLat: ko.observable(0.0),
        positionLng: ko.observable(0.0),
        listaSucursales: ko.observableArray([]),
        listaSucursalesCerca: ko.observableArray([]),
        listaCiudades: ko.observableArray([]),
        listaEstados: ko.observableArray([]),
        permisoUbicacion: ko.observable(''),
        usarUbicacion: ko.observable(false),
        inicio: inicio,
        despuesBind: despuesBind,
        irAgendarCita: irAgendarCita,

        solicitarUbicacion: solicitarUbicacion,
        getEstados: getEstados,
        getCiudades: getCiudades,
        getSucursalesCerca: getSucursalesCerca,
        getSucursalesFiltro: getSucursalesFiltro,
        getPermisoUbicacion: getPermisoUbicacion
        
    };



    function inicio() {
        return $.when(
            appVM.getEstados().done(function (d) { appVM.listaEstados(d.data); }),
            appVM.getSucursalesFiltro().done(function (d){ appVM.listaSucursales(d.data) })
        ).promise();
    }


    function despuesBind() {
        vm.getPermisoUbicacion();

        $("#precarga").fadeOut(500, function () {
            $("#app").fadeIn(500);
        });

        vm.filtroEstadoId.subscribe(function (e) {
          	$('#ajax-loader').fadeIn(100);
            vm.listaCiudades([]);
            vm.filtroCiudadId(0);
            console.log('FiltroEstadoId ' + vm.filtroEstadoId())
            if (vm.filtroEstadoId() > 0) {
                appVM.getCiudades().done(function (d) { console.log(d); appVM.listaCiudades(d.data); 
          		$('#ajax-loader').fadeOut(100);
                                                      });
            } else {
                listaCiudades([]);
            }
        });

        vm.filtroCiudadId.subscribe(function (e) {
          $('#ajax-loader').fadeIn(100);
            appVM.getSucursalesFiltro().done(function (d) { console.log(d); appVM.listaSucursales(d.data); $('#ajax-loader').fadeOut(100); })
        });

        vm.permisoUbicacion.subscribe(function (e) {
            console.log('permisoubicacion: '+ e);
            if (vm.permisoUbicacion() == 'prompt'){
                appVM.usarUbicacion(false);
            } else if (e == 'granted') {
                navigator.geolocation.getCurrentPosition(onPositionGrant,onPositionDeny, ViewBag.geoSettings);
            } else if (e == 'denied'){
                onPositionDeny();
            }
        });
    }

    function onPositionGrant(position){
        console.log('onpositiongrant');
        appVM.positionLat(position.coords.latitude);
        appVM.positionLng(position.coords.longitude);
        
        appVM.getSucursalesFiltro().done(function (d){ 
            appVM.listaSucursales(d.data); 
            appVM.usarUbicacion(true); })
        appVM.getSucursalesCerca().done(function (d){ appVM.listaSucursalesCerca(d.data) });
        
    }

    function onPositionDeny(){
        console.log('onpositiondeny');
        vm.positionLat(0);
        vm.positionLng(0);
        vm.usarUbicacion(false);
        
    }

    function getSucursalesCerca() {
        let data;

        let latitud = vm.positionLat();
        let longitud = vm.positionLng();
        

        return $.ajax({
            url: baseUrl + '/ConsultaSucursalMasCercana',
            method: 'POST',
            data: {
                Latitud: latitud,
                Longitud: longitud    
            }
        }).done(function (d) { data = d; return data; });
    }

    function getSucursalesFiltro() {
        let data;

        let latitud = vm.positionLat();
        let longitud = vm.positionLng();
        
        

        return $.ajax({
            url: baseUrl + '/ConsultaSucursalFiltro',
            method: 'POST',
            data: {
                IdEstado: vm.filtroEstadoId(),
                IdCiudad: vm.filtroCiudadId(),
                Latitud: latitud,
                Longitud: longitud
            }
        }).done(function (d) { data = d; return data; });
    }

    function getCiudades() {
        let data;

        return $.ajax({
            url: baseUrl + '/GetCiudades',
            method: 'POST',
            data: {
                IdEstadoRepublica: vm.filtroEstadoId()
            }
        }).done(function (d) { data = d; return data; });
    }

    function getEstados() {
        return $.ajax({
            url: baseUrl + '/GetEstadosRep',
            method: 'POST'
        }).done(function (d) { data = d; return data; });
    }

    function irAgendarCita(ctx){
        console.log(ctx);
        let idC = ctx.IdCiudad, 
            idE = ctx.IdEstadoRepublica,
            idS = ctx.Id;

        let builtUrl = ViewBag.UrlAgendarCita + '?iC=' + idC + '&iE=' + idE + '&iS=' + idS;
        window.location.href = builtUrl;
    }

    function solicitarUbicacion(val) {
        console.log(val);
        $('#location-prompt').fadeOut(500, function(){ });
        if (val == true){
            navigator.geolocation.getCurrentPosition(onPositionGrant,onPositionDeny, ViewBag.geoSettings);
        }
    }

    function getPermisoUbicacion(){
      if (navigator.geolocation) {
        if (navigator.permissions){
            navigator.permissions.query({name:'geolocation'}).then(function(result) {
                vm.permisoUbicacion(result.state);
                if (vm.permisoUbicacion() == 'denied'){

                }

                result.onchange = function() {
                    vm.permisoUbicacion(result.state);
                }
            });  
        } else {
          vm.solicitarUbicacion(true);
          
        }
        
      }
        
    }
    return vm;
}();

$(function () {

    $.when(appVM.inicio()).done(function () {
        console.log('inicio terminó');
        $("#app").each(function (i, n) {
            console.log('aplicar binds')
            ko.applyBindings(appVM, n);
        });

        appVM.despuesBind();
    })


});

